/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 5/17/21
 * Copyright All Rights Reserved
 */
// @flow
import React from 'react';
import isTimeBasedMetric from 'support/isTimeBasedMetric';


type ItemProps = {
  color: string,
  label: string,
}
const LegendItem = ({ color, label }: ItemProps) => (
  <span style={{ size: '14px', marginRight: '10px' }}>
    <span
      style={{
        display: 'inline-block',
        height: '15px',
        width: '15px',
        backgroundColor: color,
        marginRight: '10px',
      }}
    />
    {label}
  </span>
);

type Props = {
  performanceMetric: string,
}
const Legend = ({ performanceMetric }: Props) => {
  if (isTimeBasedMetric(performanceMetric)) {
    return (
      <div>
        <LegendItem color="#46CB18" label="< 5 days" />
        <LegendItem color="yellow" label="5-28 days" />
        <LegendItem color="orange" label="28 days – 6 months" />
        <LegendItem color="#FF0000" label="6-12 months" />
        <LegendItem color="#CB181D" label="> 12 months" />
        <LegendItem color="#888888" label="Not Specied" />
      </div>
    );
  }
  return (
    <div>
      <LegendItem color="#46CB18" label="< 5%" />
      <LegendItem color="yellow" label="5-10%" />
      <LegendItem color="orange" label="10-20%" />
      <LegendItem color="#FF0000" label="20-40%" />
      <LegendItem color="#CB181D" label="> 40%" />
      <LegendItem color="#888888" label="Not Specied" />
    </div>
  );
};

export default Legend;



// WEBPACK FOOTER //
// ./js/components/pages/Inventory/InventoryMap/Legend/index.jsx